import React from "react";
import "../Pages/PhaseDetails/PhaseDetails.css";
import { QRCodeSVG } from "qrcode.react"; // Use QRCodeSVG instead
import thememebot from "../assets/images/thememebot.png";

const TelegramDesk = () => {
  return (
    <div className="desktop">
      <div
        className="menupointer"
        style={{
          height: "100%",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          pointerEvents: "all",
          "text-transform":"uppercase"
        }}
      >
        <div style={{ maxWidth: "380px" }}>
          <div>
            <img src='https://d1ccopf5cw1hft.cloudfront.net/s3data/thememebot.png' className="desk-qr" />
            {/* <QRCodeSVG value={mobileAppUrl} className="desk-qr" /> */}
            <h2 className="desk-scan">
              This version of the app is optimized for mobile devices.
            </h2>
            <h2 className="desk-scan-colour">Scan the QR code to log in with Telegram on your phone.</h2>
            {/* <h2 className="desk-scan">
              Direct App Link:&nbsp;
              <a href="https://t.me/the_meme_tv_bot">THEMEMETV </a>
            </h2> */}
          </div>
        </div>
      </div>
    </div>
  );
};
export default TelegramDesk;
